import React from "react";

/**
 * Composant pour afficher du texte tronqué avec tooltip au survol
 * Utilise le même système que les commentaires (tooltip-trigger)
 */
class TruncatedCell extends React.Component {
  render() {
    const { text, maxLength = 30, className = "", style = {} } = this.props;

    // Si le texte est vide ou null
    if (!text || text === "N/A" || text === "Non défini" || text === "A compléter") {
      return <div className={className} style={style}>{text}</div>;
    }

    const textStr = String(text);
    const shouldTruncate = textStr.length > maxLength;

    if (!shouldTruncate) {
      return <div className={className} style={style}>{textStr}</div>;
    }

    return (
      <div className={className} style={style}>
        <span
          className="tooltip-trigger"
          data-tooltip={textStr}
        >
          {textStr.substring(0, maxLength)}...
        </span>
      </div>
    );
  }
}

export default TruncatedCell;
